<template>
  <a-modal
    title="Edit Member ID"
    :visible="open"
    :confirm-loading="submitLoading"
    @ok="submitForm"
    @cancel="cancel"
  >
    <a-form-model ref="form" :model="form" :rules="rules">
      <a-form-model-item label="Mobile">
        <a-input :value="form.mobile || '—'" disabled placeholder="No mobile" />
      </a-form-model-item>
      <a-form-model-item label="Email">
        <a-input :value="form.email || '—'" disabled placeholder="No email" />
      </a-form-model-item>
      <a-form-model-item label="Member ID" prop="userCode">
        <a-input v-model="form.userCode" placeholder="Enter member ID (user_code)" allow-clear />
      </a-form-model-item>
    </a-form-model>
  </a-modal>
</template>

<script>
import { updateMemberId } from '@/api/biz/user'

export default {
  name: 'EditMemberId',
  data () {
    return {
      submitLoading: false,
      open: false,
      form: {
        id: undefined,
        mobile: '',
        email: '',
        userCode: ''
      },
      rules: {
        userCode: [
          { required: true, message: 'Member ID is required', trigger: 'blur' },
          { min: 1, max: 64, message: 'Length 1-64', trigger: 'blur' }
        ]
      }
    }
  },
  methods: {
    show (record) {
      this.reset()
      this.form.id = record.id
      this.form.mobile = record.mobile || ''
      this.form.email = record.email || ''
      this.form.userCode = record.userCode != null ? String(record.userCode) : ''
      this.open = true
    },
    cancel () {
      this.open = false
      this.reset()
    },
    reset () {
      this.form = { id: undefined, mobile: '', email: '', userCode: '' }
      this.$nextTick(() => {
        if (this.$refs.form) {
          this.$refs.form.clearValidate()
        }
      })
    },
    submitForm () {
      this.$refs.form.validate(valid => {
        if (!valid) return
        this.submitLoading = true
        updateMemberId({ id: this.form.id, userCode: this.form.userCode.trim() })
          .then(() => {
            this.$message.success('Member ID updated')
            this.open = false
            this.$emit('ok')
          })
          .finally(() => {
            this.submitLoading = false
          })
      })
    }
  }
}
</script>
